import { render, staticRenderFns } from "./mdc-top-app-bar.vue?vue&type=template&id=3848a456&scoped=true&"
import script from "./mdc-top-app-bar.vue?vue&type=script&lang=ts&"
export * from "./mdc-top-app-bar.vue?vue&type=script&lang=ts&"
import style0 from "./mdc-top-app-bar.vue?vue&type=style&index=0&id=3848a456&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3848a456",
  null
  
)

export default component.exports